<template>
  <div>
    <a-row style="margin: 20px 0px -10px 0px">
      <!-- 左侧二维码部分 -->
      <a-col :span="9">
        <div class="login-container">
          <div class="login-title">扫码关注小程序</div>
          <div class="qr-description-top">第一时间获取最新房源信息</div>
          <img src="@/assets/efind.png" alt="" style="width: 140px" />
          <div class="qr-description-bottom">e指找房 租房无忧</div>
        </div>
      </a-col>

      <!-- 分割线 -->
      <a-col :span="3">
        <a-divider style="height: 280px" type="vertical" />
      </a-col>

      <!-- 右侧登录表单 -->
      <a-col :span="12">
        <a-form-model
          ref="loginForm"
          :model="form"
          :rules="rules"
          layout="vertical"
          class="user-layout-login"
        >
          <!-- 大标题 -->
          <div class="login-container-title">用户登录</div>

          <!-- 手机号 -->
          <a-form-model-item prop="loginId">
            <a-input
              v-model="form.loginId"
              size="default"
              type="text"
              placeholder="请输入手机号"
            >
              <a-icon
                slot="prefix"
                type="user"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-model-item>

          <!-- 密码 -->
          <a-form-model-item prop="password">
            <a-input-password
              v-model="form.password"
              size="default"
              placeholder="请输入密码"
            >
              <a-icon
                slot="prefix"
                type="lock"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input-password>
          </a-form-model-item>

          <!-- 登录按钮 -->
          <a-form-model-item>
            <a-button
              style="width: 100%"
              size="large"
              type="primary"
              html-type="submit"
              class="login-button"
              :loading="state.loginBtn"
              :disabled="state.loginBtn"
              @click="handleSubmit"
            >
              登录
            </a-button>

            <a-row type="flex" justify="space-between" style="margin-top: 10px">
              <p><a @click="changeToForget">忘记密码</a></p>
              <p><a @click="changeToRegister">没有账号？去注册</a></p>
            </a-row>
          </a-form-model-item>
        </a-form-model>
      </a-col>
    </a-row>

    <!-- 阿里云验证码容器 -->
    <div
      id="captcha-login"
      :class="captchaConfig.config.product === 'bind' ? 'hideHeight' : ''"
    >
      <AliCaptcha :captcha-config="captchaConfig" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AliCaptcha from "@/components/AliCaptcha.vue";
import { timeFix } from "@/utils/util";
export default {
  components: {
    AliCaptcha,
  },
  data() {
    return {
      form: {
        loginId: "",
        password: "",
      },
      rules: {
        loginId: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码！",
            trigger: ["blur", "change"],
          },
        ],
      },
      state: {
        loginBtn: false,
      },
      captchaObj: null,
      captchaConfig: {
        config: {
          captchaId: "e63c338c75217f3dfaccad44160f8369",
          language: "cn",
          product: "bind",
        },
        handler: this.captchaHandler,
      },
    };
  },
  methods: {
    //调用vuex中login方法
    ...mapActions(["Login"]),

    handleSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return;
        if (this.captchaConfig.config.product === "bind") {
          if (this.captchaObj) {
            this.captchaObj.showCaptcha();
          } else {
            this.$notification.warning({
              message: `登录图形验证框加载中`,
              description: `请稍后`,
            });
            return false;
          }
        } else {
          this.validate();
        }
      });
    },

    changeToRegister() {
      this.$emit("loginToRegister");
    },
    changeToForget() {
      this.$emit("loginToForget");
    },

    validate() {
      this.state.loginBtn = true;
      const _this = this;
      var result = this.captchaObj.getValidate();

      if (!result) {
        _this.$message.warning("请先完成图形验证！");
        _this.state.loginBtn = false;
        return;
      }

      _this.Login({
          lotNumber: result.lot_number,
          captchaOutput: result.captcha_output,
          passToken: result.pass_token,
          genTime: result.gen_time,
          loginId: window.btoa(_this.form.loginId),
          password: window.btoa(_this.form.password),
        })
        //登入失败在这里改动
        .then((res) => _this.loginSuccess(res))
        .catch((err) => _this.requestFailed(err))
        .finally(() => {
          setTimeout(() => {
            _this.state.loginBtn = false;
          }, 1000);
        });
    },

    captchaHandler(captchaObj) {
      const _this = this;
      this.captchaObj = captchaObj;
      captchaObj
        .appendTo("#captcha-login")
        .onReady(function () {
          console.log("ready");
        })
        .onNextReady(function () {
          console.log("nextReady");
        })
        .onBoxShow(function () {
          console.log("boxShow");
        })
        .onError(function (e) {
          _this.$notification.warning({
            message: `网络链接异常`,
            description: `请重试`,
          });
          console.log("网络链接异常");
          console.log(e);
        })
        .onSuccess(() => {
          if (this.captchaConfig.config.product === "bind") {
            this.validate();
          }
        });
    },

    loginSuccess(res) {
      console.log(res)
      // 延迟 1 秒显示欢迎信息
      if (res.code == "200") {
        setTimeout(() => {
          this.$notification.success({
            message: "登录成功",
            description: `${timeFix()}，欢迎回来`,
          });
          this.$emit("closeLogin");
        }, 300);
      } else {
        this.$notification["error"]({
          message: "错误",
          description: res.msg,
        });
      }
    },
    //服务器报错时发生
    requestFailed(err) {
      this.$notification["error"]({
        message: "错误",
        description:
          ((err.response || {}).data || {}).message || "网络异常，请稍后再试",
        duration: 4,
      });
    },
  },
};
</script>

<style scoped>
.login-container {
  text-align: center;
  padding: 10px;
}
.login-title {
  font-size: 22px;
  margin-bottom: 10px;
  color: #333333;
}
.qr-description-top {
  color: #666;
  margin-bottom: 10px;
}
.qr-description-bottom {
  color: #666;
  margin-top: 20px;
}
.login-container-title {
  font-size: 22px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 26px;
  letter-spacing: 1px;
  color: #333333;
}
</style>
